import React, { useState, FunctionComponent, useRef, useCallback, useEffect } from 'react';
import { Presentation } from './presentation';
import { ResumeStates, JobResumeStates } from '../../../types/personShow';

type Props = {
  onChangedBody: (name: string, value: any) => void;
  target: 'resume' | 'job_resume'
  resume: ResumeStates;
  job_resume: JobResumeStates;
  isPc: boolean;
  deleted: boolean;
  loading: boolean;
};

export const Component: FunctionComponent<Props> = ({
  onChangedBody,
  target,
  resume,
  job_resume,
  isPc,
  deleted,
  loading,
}) => {
  const [flash, setFlash] = useState(false);
  const [flashClass, setFlashClass] = useState('');
  const [flashMessage, setFlashMessage] = useState('');
  const fileInput = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (deleted && !isPc) {
      setFlash(true);
      setFlashClass('success');
      setFlashMessage('書類を削除しました');
    }
  }, [deleted]);

  const handleFileInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (file.size > 5242880) {
      alert('サイズが大きすぎます。推奨容量（1MB）以下にして下さい。');
      if (!isPc) {
        setFlash(true);
        setFlashClass('danger');
        setFlashMessage('アップロードが失敗しました');
      }
      return
    }

    if (target === 'resume') {
      const newState = { resume: file } as ResumeStates;
      onChangedBody('resume', newState);
    } else {
      const newState = { job_resume: file } as JobResumeStates;
      onChangedBody('job_resume', newState);
    }

    if (!isPc) {
      setFlash(true);
      setFlashClass('success');
      setFlashMessage('アップロードが成功しました');
    }
  };

  const handleFlash = useCallback((flash: boolean, flashType: string, flashMessage: string) => {
    setFlash(flash);
    setFlashClass(flashType);
    setFlashMessage(flashMessage);
  }, []);

  return (
    <Presentation
      isPc={isPc}
      target={target}
      resume={resume}
      jobResume={job_resume}
      flash={flash}
      flashClass={flashClass}
      flashMessage={flashMessage}
      deleted={deleted}
      fileInputRef={fileInput}
      loading={loading}
      onFileInputChange={handleFileInputChange}
      handleFlash={handleFlash}
    />
  );
};
